import { Box } from "@mui/material";

interface AppLayoutPageWrapperDesktopProps {
  children: React.ReactNode;
}

/**
 * Wrapper for the page content of the app layout
 * Renders next to the navigation menu and wraps the page content
 * Should be rendered within a specific route component!
 */
export function AppLayoutPageWrapperDesktop(props: AppLayoutPageWrapperDesktopProps) {
  const { children } = props;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: 0,
        backgroundColor: theme.palette.background.page,
        flex: 1,
        borderRadius: theme.borderRadius?.xLarge,
        boxShadow: theme.palette.background?.pageShadow,
        overflow: "auto",
        // Use margin to show gradient background, but keep it within flex container
        margin: 4,
        marginLeft: 0, // No left margin (navigation handles its own spacing)
        marginTop: 0, // No top margin (header is above)
      })}
    >
      {children}
    </Box>
  );
}
